import { useEffect } from "react";

// Shared public-page SEO: title, meta description, canonical, robots(noindex), and JSON-LD.
export function useSeo({ title, description, canonical, noindex, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;
    const set = (sel, create) => {
      let el = document.head.querySelector(sel);
      if (!el) { el = create(); document.head.appendChild(el); }
      return el;
    };
    const desc = set('meta[name="description"]', () => Object.assign(document.createElement("meta"), { name: "description" }));
    if (description) desc.setAttribute("content", description);
    const can = set('link[rel="canonical"]', () => Object.assign(document.createElement("link"), { rel: "canonical" }));
    if (canonical) can.setAttribute("href", canonical);
    const robots = set('meta[name="robots"]', () => Object.assign(document.createElement("meta"), { name: "robots" }));
    robots.setAttribute("content", noindex ? "noindex,nofollow" : "index,follow");
    document.querySelectorAll("script[data-mmm-jsonld]").forEach((s) => s.remove());
    if (jsonLd && jsonLd.length) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-mmm-jsonld", "1");
      s.textContent = JSON.stringify(jsonLd.length === 1 ? jsonLd[0] : jsonLd);
      document.head.appendChild(s);
    }
    return () => { document.querySelectorAll("script[data-mmm-jsonld]").forEach((s) => s.remove()); };
  }, [title, description, canonical, noindex, jsonLd]);
}

// Fire-and-forget FAQ analytics tracking.
export function trackFaq(publicApi, payload) {
  try { publicApi.post("/public/faq/track", payload).catch(() => {}); } catch { /* noop */ }
}
